/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_This_YearInputs */

const en_date_this_year = /** @type {(inputs: Date_This_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Year`)
};

/**
* | output |
* | --- |
* | "This Year" |
*
* @param {Date_This_YearInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const date_this_year = /** @type {((inputs?: Date_This_YearInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_This_YearInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_date_this_year(inputs)
});